<template>
<div class="col-md-12">
    <div class="card">
        <div class="card-header">
             <b-row>
                <b-col>
                   <h4> Devoluções Solicitadas </h4>
                </b-col>
                <b-col style="text-align: right;">
                    <button class="btn btn-primary" @click="devolucoes">Solicitar uma devolução</button>
                    <button class="btn btn-success" v-if="enviar.length > 0" @click="EnviarDevolucao"><i class="fa fa-send"></i> Enviar Devoluções</button>        
                </b-col>
            </b-row>  
        </div>          
        <div class="card-body">

            <p v-if="totalSelecionados > 0" class="text-left" style="margin-bottom: 0px;">
                <strong class="text-primary">Devoluções Selecionadas: </strong>{{enviar.length}}
            </p>

            <v-table :column="colunas" :data="dataComputed" :actions="actionsTable" @change="changeSelecionados" @show='show' @markAll="changeMarcarTodos"></v-table>

            <!--<button class="btn btn-success" @click="EnviarDevolucao"><i class="fa fa-send"></i> Enviar Devoluções</button> -->
        </div>
    </div>
    <!------------------------------------- MODAL DE DETALHAMENTO DE DEVOLUCAO -------------------------------------------->

    <div class="modal fade" id="modal-Devolve" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title text-primary">Solicitação de Devolução da Nota <small>{{danfe.numero}}</small></h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ul class="text-danger">
                        <li v-for="error in errors" :key="error">{{error}}</li>
                        <input type="hidden" v-model="danfe.danfe_id">

                    </ul>
                    <div v-if="danfe.status =='LIBERADO'">
                        <div v-if="danfe.analise.length > 0">
                            <h4>
                                Demostrativo da análise, mediante a solicitação de devolução.
                            </h4>
                            <br>
                            <div class="card">
                                <div class="card-body">
                                    <table class="table table-bordered table-condensed table-hover">
                                        <thead>
                                            <tr>
                                                <th>Regras</th>
                                                <th>% Multa</th>
                                                <th>Quantidade</th>
                                                <th>Media</th>
                                                <th>NF. Vs Media</th>
                                                <th>Taxa</th>
                                                <th>Subtotal</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(an,i) in danfe.analise" :key="i">
                                                <td> {{an.descricao}} </td>
                                                <td> {{ an.multa }} % </td>
                                                <td> {{ an.quantidade }} </td>
                                                <td> R$ {{ parseFloat(an.media).toLocaleString('pt-BR')  }} </td>
                                                <td> R$ {{ parseFloat(an.nf_x_media).toLocaleString('pt-BR') }} </td>
                                                <td> R$ {{ parseFloat(an.taxa).toLocaleString('pt-BR') }} </td>
                                                <td> R$ {{ parseFloat(an.total).toLocaleString('pt-BR') }} </td>

                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>

                        </div>

                        <textarea v-model="danfe.obs" class="form-control" readonly></textarea>

                    </div>
                    <div v-if="danfe.status =='ABERTO' || danfe.status !='LIBERADO' ">

                        <div class="row">
                            <div class="col-md-4">
                                <h5>Revendedora</h5>
                            </div>
                            <div class="col-md-6">
                                <span>{{ danfe.nome }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <h5>Chave da Nota</h5>
                            </div>
                            <div class="col-md-6">
                                <span>{{ danfe.chave }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <h5>Número da Nota</h5>
                            </div>
                            <div class="col-md-6">
                                <span>{{danfe.numero}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Tipo Devolução:</label>
                                    <select class="form-control" v-model="danfe.tipo" id="tipo-devolve">
                                        <option :value="1">Total</option>
                                        <option :value="2">Parcial</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Tipo de Frete:</label>
                                    <select class="form-control" v-model="danfe.frete" id="tipo-frete">
                                        <option :value="1">Proprio</option>
                                        <option :value="2">Coleta</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Justificativa:</label>
                                    <textarea class="form-control" rows="2" cols="3" v-model="danfe.justificativa"></textarea>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <img v-if="files" :src="files" class="img-rounded vue-image" width="200">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group" v-if="danfe.tipo == 2">
                                <table class="table table-responsive">
                                    <thead>
                                        <th>Selecione...</th>
                                        <th>Produto</th>
                                        <th>Descricao</th>
                                        <th>Quantidade</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="itens in danfe.itens" :key="itens.id">
                                            <td>
                                                <input type="checkbox" v-model="itensDevolve" :value="itens.id">
                                            </td>
                                            <td>
                                                {{itens.produto}}
                                            </td>
                                            <td>
                                                {{itens.descricao}}
                                            </td>
                                            <td>
                                                {{itens.quantidade}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <span class="disabled" v-if="danfe.status =='ABERTO' ">
                        <b-button variant="primary" id="botao-salvar" @click="salvaAlteracao"><i class="fa fa-arrow-circle-right"></i> Alterar</b-button>
                    </span>
                    <span v-if="danfe.status =='ABERTO'">
                        <button type="button" class="btn btn-warning" data-dismiss="modal" @click="deleta(danfe.devolucao)"><i class="fas fa-trash"></i> Deletar</button>
                    </span>
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Cancelar</button>
                    <span v-if="danfe.status =='ABERTO' ">
                        <!--     <button type="button" class="btn btn-warning" data-dismiss="modal" @click="encerrar(danfe.devolucao)"><i class="fa fa-eraser"></i> Encerrar</button> -->
                    </span>

                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
export default {
    data() {
        return {
            datePickerConfig: {
                'format': 'D/MM/YYYY',
                'showClose': true
            },
            modalVisible: false,
            search: "",
            colunas: [
                ['Lote', 'lote'],
                ['Nota Fiscal.', 'numero'],
                ['Revendedora', 'revendedora'],
                ['Data da Solicitação', 'data_devolucao'],
                ["Tipo Devolução", "tipo_devolucao"],
                ["Status", "status"]
            ],
            data: [],
            tipo: 0,
            frete: 0,
            files: [],
            danfe_id: 0,
            justificativa: "",
            revendedora_id: 0,
            itensDevolve: [],
            image: '',
            chave: 0,
            existeDevolucao: 0,
            totalSelecionados: 0,
            enviar: [],
            danfe: {
                numero: 0,
                chave: 0,
                tipo: "",
                valor: "",
                itens: [],
                pedidos: 0,
                revendedora: 0
            },
            errors: []
        }
    },
    methods: {
        devolucoes() {
            window.location.href = '/distribuidor/devolucao'
        },
        getAnexos(id) {
            let url = '/distribuidor/devolucao/anexo/' + id;
            axios.get(url).then(response => {
                if (response.data) {
                    this.files = response.data;
                    console.log('resposta do anexo...' + response.data);
                }
            });
        },
        loadData() {
            $(".loading").show();
            var vm = this;
            axios.get('/distribuidor/devolucao/consultar').then(function (response) {
                vm.formatDataToTable(response.data)
                $(".loading").hide();
            }).catch(function (errors) {
                console.log(errors);
                $('.loading').hide();
            });
        },
        formatDataToTable(dataLoaded) {
            var data = [];
            var pedido = {};
            pedido = dataLoaded.pedidos;
            //console.log(dataLoaded);
            dataLoaded.forEach(function (el, index) {
                let obj = {};
                obj.id = el.devolucao.id;
                obj.lote = el.lote;
                obj.created_at = moment(el.updated_at).format('DD/MM/YYYY');
                obj.danfe_id = el.devolucao.danfe_id;
                obj.numero = el.numero;
                obj.revendedora = el.pedidos.revendedora.nome;
                obj.status = el.devolucao.status;
                obj.tipo_devolucao = el.devolucao.tipo_devolucao,
                    obj.data_devolucao = moment(el.devolucao.created_at).format('DD/MM/YYYY');
                obj.selectable = el.devolucao.status == 'ABERTO';
                data.push(obj);
            });

            this.data = data;
        },
        show(danfe_id) {

            var vm = this;
            var ob1 = [];
            var itensSeleciona = [];
            var anexo = "";
            $('.loading').show();
            axios.get('/distribuidor/devolucao/busca/' + danfe_id).then(function (response) {

                let revendedor = response.data;

                revendedor.forEach(function (a, b) {
                    vm.danfe.nome = a.pedidos.revendedora.nome;
                    vm.danfe.numero = a.numero;
                    vm.danfe.chave = a.chave;
                    vm.danfe.titulo = a.titulo;
                    vm.danfe.revendedora = a.pedidos.revendedora_id;
                    vm.danfe.justificativa = a.devolucao.justificativa;
                    ob1 = a.itens;
                    vm.danfe_id = a.id
                    vm.revendedora_id = a.pedidos.revendedora.id;
                    vm.chave = a.chave;
                    vm.danfe.devolucao = a.devolucao.id;
                    vm.danfe.status = a.devolucao.status;
                    vm.danfe.obs = a.devolucao.obs;
                    vm.danfe.anexo = a.devolucao.anexo;
                    vm.danfe.analise = a.devolucao.analise;
                    anexo = a.devolucao.anexo;

                    if (a.devolucao.itens != null) {
                        itensSeleciona = a.devolucao.itens.split(",");
                        itensSeleciona.forEach(function (c) {
                            vm.markDevolucao(c);
                        });
                    }

                    let tpo = a.devolucao.tipo_devolucao;

                    if (tpo == 'TOTAL') {
                        vm.danfe.tipo = 1;
                    } else {
                        vm.danfe.tipo = 2;
                    }
                    let tpfrete = a.devolucao.frete;

                    if (tpfrete == 'COLETA') {
                        vm.danfe.frete = 2;
                    } else {
                        vm.danfe.frete = 1;
                    }
                });

                if (anexo != "") {
                    vm.getAnexos(anexo);
                }

                ob1.forEach(function (c, d) {
                    let obj = {};
                    obj.produto = c.produto.codigo;
                    obj.descricao = c.produto.nome;
                    obj.quantidade = c.quantidade;
                    obj.danfe_id = c.danfe_id;
                    obj.id = c.id
                    vm.danfe.itens.push(obj);
                });

                $('.loading').hide();
                $('#modal-Devolve').modal();

                if (this.existeDevolucao > 0) {
                    $('#botao-salvar').hide();
                }

            }).catch(function (errors) {
                //console.log(errors);
                $('.loading').hide();
            });

        },
        salvaAlteracao() {
            var vm = this;
            $(".loading").show();
            let url = '/distribuidor/devolucao/salva'
            var tp = "";
            if (vm.danfe.tipo == 1) {
                tp = 'TOTAL';
            } else {
                tp = 'PARCIAL';
            }
            let data = {
                id: vm.danfe.devolucao,
                justificativa: vm.danfe.justificativa,
                tipo: tp,
                frete: vm.danfe.frete,
                itens: vm.itensDevolve,
                revendedora_id: vm.danfe.revendedora,
            }
            axios.post(url, data).then(function (response) {
                console.log(response.data);                
                vm.loadData();
                $(".loading").hide();
                $('#modal-Devolve').modal('hide');
                vm.$swal('Devolução alterada com sucesso', '', 'success')
            }).catch(function (error) {
                var errors = error.response.data.errors;
                if (typeof (errors) == "object") {
                    console.log(errors);
                    alert(errors.join('\n'));
                } else {
                    alert(errors);
                }
                $(".loading").hide();
            });

        },
        markDevolucao(id) {
            var vm = this;
            var indices = [];
            var idx = vm.itensDevolve.indexOf(id);

            if (idx === -1) {
                vm.itensDevolve.push(id)
            } else {
                vm.itensDevolve.splice(idx);
            }
        },

        deleta(id) {

            var vm = this;
            if (vm.danfe.status != 'ABERTO') {
                this.$swal('Desculpe', 'Esta devolução já está em andamento e não poderá ser deletada, apenas encerrada.', 'error');
            }
            let url = '/distribuidor/devolucao/deletar/' + id
            axios.get(url).then(function (response) {
                console.log(response.data);
                vm.loadData();
                $(".loading").hide();
                $('#modal-Devolve').modal();
                vm.$swal('Devolução excluida com sucesso', '', 'success');
            }).catch(function (error) {
                var errors = error.response.data.errors;
                if (typeof (errors) == "object") {
                    console.log(errors);
                    alert(errors.join('\n'));
                } else {
                    alert(errors);
                }
                $(".loading").hide();
            });

        },
        encerrar(id) {
            var vm = this;
            let data = {
                id: id
            }
            let url = '/distribuidor/devolucao/encerrar/' + id
            axios.get(url).then(function (response) {
                console.log(response.data);
                window.location.href = '/distribuidor/devolucao/acompanhar';
                vm.$swal('Devolução encerrada com sucesso', '', 'success');
            }).catch(function (error) {
                var errors = error.response.data.errors;

                if (typeof (errors) == "object") {

                    console.log(errors);
                    alert(errors.join('\n'));

                } else {
                    alert(errors);
                }

                $(".loading").hide();
            });
        },
        changeSelecionados(checked, id) {

            let index = this.enviar.indexOf(id);
            if (checked) {

                if (index === -1) {
                    this.enviar.push(id);
                }
            } else {

                if (index > -1) {
                    this.enviar.splice(index, 1);
                }
            }
        },
        changeMarcarTodos(check) {

            if (!check) {
                this.enviar = [];
                return;
            }
            var vm = this;
            vm.data.forEach(function (data) {
                if (check && data.status === "ABERTO" && vm.enviar.indexOf(data.id) < 0) {

                    vm.changeSelecionados(data.id)
                    vm.enviar.push(data.id);
                    console.log(vm.enviar);
                }

            });
        },
        EnviarDevolucao() {
            if (this.enviar.length == 0) {
                this.$swal('Ops', 'Selecione ao menos uma devolução antes de enviar.', 'error');
                return;
            }
            const vm = this;
            this.enviar.forEach(function (a) {
                if (a != 'undefined') {
                    $(".loading").show();
                    let url = '/distribuidor/devolucao/enviar/' + a
                    axios.get(url).then(function (response) {
                        console.log(response.data);
                        vm.loadData();
                        vm.enviar.length = 0;
                        //vm.$swal('Devolução encerrada com sucesso','', 'success');
                        $(".loading").hide();
                    }).catch(function (error) {
                        var errors = error.response.data.errors;
                        if (typeof (errors) == "object") {
                            console.log(errors);
                            vm.$swal('Atenção esta nota não será devolvida.', errors.join('\n'), 'error');
                        } else {
                            vm.$swal('Atenção esta nota não será devolvida.', errors, 'error');
                        }
                        $(".loading").hide();
                        return
                    });
                }
            });
            this.loadData();
            //window.location.href = '/distribuidor/devolucao/acompanhar';

        }
    },
    computed: {
        actionsTable: function () {
            //console.log(this.data);
            let actions = ['show', 'select'];
            if (this.data.status === '' || this.data.status === 'TODOS') {
                actions = ['show', 'select'];
            }
            if (this.data.status === 'ABERTO') {
                actions.push('select');
            } else if (this.data.status === "REJEITADO") {
                actions = ['show'];
            } else if (this.data.status === "ENVIADO") {
                actions = ['show']
            }

            return actions;
        },
        filteredData() {
            return this.data.filter(item => {
                return item.id.toLowerCase().indexOf(this.search.toLowerCase()) > -1
            });
        },
        dataComputed() {
            return this.data;
        }
    },

    mounted() {
        this.loadData();
    }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/devolucao/List.vue